module.exports = __webpack_public_path__ + "media/images/city_img/p-e00c3a322ca645d8e2c69ebd19490576.jpg";